(function ($) {
  $.fn.onClassChange = function (cb) {
    return $(this).each((_, el) => {
      new MutationObserver(mutations => {
        mutations.forEach(mutation => cb && cb(mutation.target, mutation.target.className));
      }).observe(el, {
        attributes: true,
        attributeFilter: ['class'] // only listen for class attribute changes
      });
    });
  };
  $('.powermail_form').find('.o-input').onClassChange((el, newClass) => {
    if ($(el).val().length !== 0 && newClass.length !== 0) {
      const newClasses = newClass.split(' ');
      if ($.inArray('powermail_field_error', newClasses) !== -1) {
        $(el).removeClass('is-valid');
      } else {
        $(el).addClass('is-valid');
      }
    }
  });
})($);